import { useTranslation } from 'react-i18next'
import { X } from 'lucide-react'
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from '@quebon/ui/components/dialog'
import { PasswordChangeForm } from './PasswordChangeForm'

interface PasswordChangeDialogProps {
  open: boolean
  onClose: () => void
}

export function PasswordChangeDialog({ open, onClose }: PasswordChangeDialogProps) {
  const { t } = useTranslation('learner')

  return (
    <Dialog open={open} onOpenChange={(nextOpen) => !nextOpen && onClose()}>
      <DialogContent
        showCloseButton={false}
        overlayClassName="bg-black/20 backdrop-blur-[1px]"
        className="gap-5 rounded-2xl bg-lc-bg-primary p-6 text-lc-text-primary shadow-lc-v3-card ring-0 sm:max-w-[480px]"
      >
        <DialogHeader className="flex-row items-center justify-between gap-4">
          <DialogTitle className="text-lc-v3-h5 font-bold leading-[1.5] text-lc-v3-gray-950">
            {t('profile.section.password')}
          </DialogTitle>
          <button
            type="button"
            onClick={onClose}
            aria-label={t('profile.password.close')}
            className="flex size-8 shrink-0 items-center justify-center rounded-2xl text-lc-text-secondary hover:bg-lc-v3-gray-100 focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-lc-key-500"
          >
            <X className="size-6" aria-hidden="true" />
          </button>
        </DialogHeader>
        {open ? <PasswordChangeForm onSuccess={onClose} /> : null}
      </DialogContent>
    </Dialog>
  )
}
